import get from 'lodash/get'

export const getInObject = (object: any, path: string | string[], defaultValue?: any) => {
  return get(object, path, defaultValue)
}

export default getInObject
